import type { KnowledgeBaseRepository } from "../repositories/knowledge-base-repository"

export const makeGetKnowledgeBase = (repo: KnowledgeBaseRepository) =>
  (id: string) =>
    repo.getById(id)
